angular.module('leanlaw').controller('MatterTagRevenueDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', 'accountingService', "exportJson", "singleRequest", "messageBus", 'matterTagsService', function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, userService, reportsService, commonFilterService, accountingService, exportJson, singleRequest, messageBus, matterTagsService) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.goToSummary = function (clientId, matterId) {
    $state.go('reports.practice-area-revenue-invoices', {
      clientId,
      matterId,
      matterTag: $stateParams.matterTag
    });
  };
  function exportLine(client, matter, data, total) {
    const include = $scope.filter.include;
    let line = {
      "Client": client
    };
    if (include.matters) {
      line[$scope.me.terms.Matter] = matter;
    }
    if (include.detail) {
      line["Billed Hours"] = $filter("amount")(data.billed.hours);
      line["Billed Expenses"] = $filter("amount")(data.billed.expensesTotal);
      line["Billed Fixed fees"] = $filter("amount")(data.billed.chargesTotal);
      line["Billed Credits"] = $filter("amount")(data.billed.credits);
      if (total.billed.adjustments) {
        line["Adjustments"] = $filter("amount")(data.billed.adjustments);
      }
      if (total.billed.tax) {
        line["Tax"] = $filter("amount")(data.billed.tax);
      }
    }
    const label = include.detail ? "Total Billed" : "Billed";
    line[label] = $filter("amount")(data.billed.total);
    line["Collected"] = data.collected.servicesTotal ? $filter("amount")(data.collected.servicesTotal) : "";
    if ($scope.accounting && $scope.trust) {
      line["Trust balance"] = data.accounting && data.accounting.trustBalance ? $filter("amount")(data.accounting.trustBalance) : "";
    }
    if ($scope.accounting) {
      line["Receivables balance"] = data.accounting && data.accounting.balance ? $filter("amount")(data.accounting.balance) : "";
    }
    return line;
  }
  $scope.export = function () {
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      accum.push(exportLine(c.client.label, "", c.data, $scope.data.data));
      if ($scope.filter.include.matters) {
        c.matters.forEach(m => {
          accum.push(exportLine("", m.matter.label || m.matter.name, m.data, $scope.data.data));
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.trust = me.company.settings.trustEnabled;
      $scope.me = me;
      $scope.ready = true;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
      }).catch(err => {
        $scope.accounting = false;
      });
      matterTagsService.getMatterTags().then(mattertags => {
        $scope.matterTag = mattertags.find(t => t.id === $stateParams.matterTag);
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
        filterClientEntries();
        // });
      });
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
  }
  function filterClientEntries() {
    if (!$scope.ready) return;
    $scope.loading = true;
    const query = angular.copy($scope.filter);
    query.billingType = '-internal';
    query.data = "invoices,payments";
    query.reportType = "revenue";
    query.matterTag = $scope.matterTag || {
      id: 'none'
    };
    singleRequest.serviceCall("filterClientEntries", reportsService.getClientReport)(query).then(data => {
      if (!data) return;
      $scope.loading = false;
      $scope.data = data;
    }).catch(alerts.error);
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("filterClientEntries");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);